import { render, staticRenderFns } from "./config.vue?vue&type=template&id=583441ae"
import script from "./config.vue?vue&type=script&lang=js"
export * from "./config.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/html/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('583441ae')) {
      api.createRecord('583441ae', component.options)
    } else {
      api.reload('583441ae', component.options)
    }
    module.hot.accept("./config.vue?vue&type=template&id=583441ae", function () {
      api.rerender('583441ae', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/modulestore/module/1-2-banner-swiper/config.vue"
export default component.exports